import React, { Component } from 'react';
import styled from 'styled-components';
import Header from './Header';
import Footer from './Footer';


const StyledPageWrapper = styled.div`
    max-width: ${props => props.theme.unit * 172}px;
    margin: 0 auto;
`;

const StyledMain = styled.main`
    padding: ${props => props.theme.unit * 10}px ${props => props.theme.unit * 5}px;

    @media (max-width: ${props => props.theme.breakpoint.md}px) {
        padding-left: ${props => props.theme.unit * 5}px;
        padding-right: ${props => props.theme.unit * 5}px;
    }

    @media (max-width: ${props => props.theme.breakpoint.sm}px) {
        overflow: hidden;
        padding: ${props => props.theme.unit * 5}px ${props => props.theme.unit * 2}px;
    }
`;

class PageWrapper extends Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        const { children } = this.props;

        return (
            <StyledPageWrapper>
                <Header />
                <StyledMain>
                    { children }
                </StyledMain>
                <Footer />
            </StyledPageWrapper>
        );
    }
}

export default PageWrapper;
